import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=c8be483e"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8be483e')) {
      api.createRecord('c8be483e', component.options)
    } else {
      api.reload('c8be483e', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=c8be483e", function () {
      api.rerender('c8be483e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/operation/admin.vue"
export default component.exports